import {HexColor, RGB} from '../../@types/colors';

export function RGBToHex(rgb: RGB): HexColor {
	const tuple = Array.isArray(rgb) ? rgb : [rgb.R, rgb.G, rgb.B];

	return '#' + tuple.map(value => {
		const hex = Math.round(value).toString(16);

		return hex.padStart(2, '0');
	}).join('');
}
